/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Ev_RoomInputs */

const en_fw_notify_ev_room = /** @type {(inputs: Fw_Notify_Ev_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room (guest joined, handed off)`)
};

const id_fw_notify_ev_room = /** @type {(inputs: Fw_Notify_Ev_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Rancang (tamu bergabung, diserahkan)`)
};

/**
* | output |
* | --- |
* | "Design Room (guest joined, handed off)" |
*
* @param {Fw_Notify_Ev_RoomInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_ev_room = /** @type {((inputs?: Fw_Notify_Ev_RoomInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Ev_RoomInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_ev_room(inputs)
	return en_fw_notify_ev_room(inputs)
});